/*
==========================================
WEESGAARD PREMIUM AMBASSADORS
==========================================
*/

(() => {

"use strict";

const slider=document.querySelector(".wg-carousel");

if(!slider) return;

const track=slider.querySelector(".wg-carousel-track");

const cards=[...slider.querySelectorAll(".wg-ambassador-card")];

let isDown=false;
let startX;
let scrollLeft;
let auto;

/*==========================================
AUTO SCROLL
==========================================*/

function startAuto(){

stopAuto();

auto=setInterval(()=>{

slider.scrollLeft+=1;

if(

slider.scrollLeft>=
(slider.scrollWidth-slider.clientWidth-5)

){

slider.scrollLeft=0;

}

},18);

}

function stopAuto(){

clearInterval(auto);

}

startAuto();

/*==========================================
HOVER
==========================================*/

slider.addEventListener("mouseenter",stopAuto);

slider.addEventListener("mouseleave",startAuto);

/*==========================================
DRAG
==========================================*/

slider.addEventListener("mousedown",(e)=>{

isDown=true;

slider.classList.add("is-dragging");

startX=e.pageX;

scrollLeft=slider.scrollLeft;

stopAuto();

});

window.addEventListener("mouseup",()=>{

if(!isDown) return;

isDown=false;

slider.classList.remove("is-dragging");

startAuto();

});

slider.addEventListener("mousemove",(e)=>{

if(!isDown) return;

e.preventDefault();

const walk=(e.pageX-startX)*1.6;

slider.scrollLeft=scrollLeft-walk;

});

/*==========================================
TOUCH
==========================================*/

slider.addEventListener("touchstart",stopAuto,{passive:true});

slider.addEventListener("touchend",startAuto);

/*==========================================
MOUSE WHEEL
==========================================*/

slider.addEventListener("wheel",(e)=>{

e.preventDefault();

slider.scrollLeft+=e.deltaY;

},{passive:false});

/*==========================================
ACTIVE CARD
==========================================*/

function activeCard(){

const center=

slider.scrollLeft+
slider.clientWidth/2;

cards.forEach(card=>{

const middle=

card.offsetLeft+
(card.clientWidth/2);

const distance=

Math.abs(center-middle);

if(distance<150){

card.classList.add("is-active");

}else{

card.classList.remove("is-active");

}

});

}

slider.addEventListener("scroll",activeCard);

activeCard();

/*==========================================
REVEAL
==========================================*/

const observer=new IntersectionObserver((entries)=>{

entries.forEach(entry=>{

if(entry.isIntersecting){

entry.target.classList.add("is-visible");

}

});

},{
threshold:.15
});

cards.forEach(card=>observer.observe(card));

})();